export default __webpack_public_path__ + "static/media/yellow_bg.cbf0ab24.png";